<ng-container *ngIf="taskLoaded() && isInfoLoaded()">
  <div class="wrapper wrapper-content">
    <div class="container-fluid">
      <div class="row ml-1">
        <!-- zona de widgets -->
        <!-- WIDGET OFERTAS RECIIDAS -->
        <div class="widget-container col-12 col-md-4">
          <div class="widget row style1 bg-secondary text-light">
            <div class="col-4" style="display:inline-block;">
              <i class="fa fa-5x fa-inbox"></i>
            </div>
            <div class="col-8 float-right">
              <span>{{ 'AwardInfo.tenderList' | translate }}</span>
              <h2 class="font-bold"> {{ tendersList ? tendersList.length : '0' }} </h2>
            </div>
          </div>
        </div>
        <!-- WIDGET LOTES PENDIENTES DE ADJUDICAR -->
        <div class="widget-container col-12 col-md-4" *ngIf="project?.breakdownLot.apportioned">
          <div class="widget row style1 bg-azul1">
            <div class="col-4" style="display:inline-block;">
              <i class="fa fa-5x fa-clone"></i>
            </div>
            <div class="col-8 float-right">
              <span>{{ 'AwardInfo.pendingLots' | translate }} </span>
              <h2 class="font-bold"> {{ avalaibleLots ? avalaibleLots.length : '0' }} </h2>
            </div>
          </div>
        </div>
        <!-- WIDGET CONTRATOS CREADOS -->
        <div class="widget-container col-12 col-md-4">
          <div class="widget row style1 bg-primary">
            <div class="col-4" style="display:inline-block;">
              <i class="fa fa-5x fa-file-signature"></i>
            </div>
            <div class="col-8 float-right">
              <span> {{ 'AwardInfo.awardsList' | translate }} </span>
              <h2 class="font-bold"> {{ contadorContratos }} </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-t-md">
        <!-- LISTADO DE CONTRATOS -->
        <div class="col-12 p-0">
          <p-panel class="mb-3" [toggleable]="true">
            <!-- A) TITULO OFERTA -->
            <p-header>
              <span>
                <i class="fa fas fa-lg fa-file-signature"></i>
                <span> {{ 'AwardInfo.awardsProject' | translate }}</span></span>
            </p-header>
            <div class="col-12">
              <p-table [value]="awardsList" sortField="startInfo.date" sortOrder="1" [rows]="20" [paginator]="false"
                [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]" class="footer-over-pagination mb-3"
                [scrollable]="false" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="TEXTTH  th-wrap"><span pTooltip="{{ 'AwardInfo.table.description' | translate }}">{{
                        'AwardInfo.table.description' | translate }}</span></th>
                    <th class="LONGTEXTTH  th-wrap"><span pTooltip="{{ 'AwardInfo.table.award' | translate }}">{{
                        'AwardInfo.table.award' | translate }}</span></th>
                    <th *ngIf="project?.breakdownLot.apportioned" class="TEXTTH"><span
                        pTooltip="{{ 'AwardInfo.table.lots' | translate }}">{{ 'AwardInfo.table.lots' | translate
                        }}</span>
                    </th>
                    <th class="TEXTTH th-wrap"><span pTooltip="{{ 'AwardInfo.table.state' | translate }}">{{
                        'AwardInfo.table.state' | translate }}</span></th>
                    <th class="DATETH th-wrap"><span pTooltip="{{ 'AwardInfo.table.awardDate' | translate }}">{{
                        'AwardInfo.table.awardDate' | translate }}</span></th>
                    <th class="DATETH th-wrap"><span pTooltip="{{ 'AwardInfo.table.formalizationDate' | translate }}">{{
                        'AwardInfo.table.formalizationDate' | translate }}</span></th>
                    <th class="DATETH th-wrap"><span pTooltip="{{ 'AwardInfo.table.warranties' | translate }}">{{
                        'AwardInfo.table.warranties' | translate }}</span></th>
                    <th class="action-button text-right"><span pTooltip="{{ 'AwardInfo.table.actions' | translate }}">{{
                        'AwardInfo.table.actions' | translate }}</span></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-award>
                  <tr class="align-top">
                    <td class="TEXT"><a class="pr-2" *ngIf="award.validation" (click)="showValidationResult(award)">
                        <i class="fas fa-lg fa-exclamation-circle"
                          pTooltip="{{ 'TenderDefinition.click2ShowErrors' | translate }}" tooltipPosition="right"
                          [ngClass]="(award.validation.result === ResultType.ERROR) ? 'text-danger' : 'text-warning'"></i></a><span
                        pTooltip="{{ award.description }}">{{ award.description }}</span></td>
                    <td class="LONGTEXT"
                      pTooltip="{{ award?.company?.taxIdentifier }} - {{ award?.company?.commercialName}}"> {{
                      award?.company?.taxIdentifier }} - {{ award?.company?.commercialName}}</td>
                    <td class="TEXT" *ngIf="project?.breakdownLot.apportioned">
                      <div *ngFor="let lote of award.awardsLots; let i = index"> [{{ lote.projectLot.lotNumber }}] <span
                          pTooltip="{{ lote.projectLot.description }}" *ngIf="lote.projectLot.description">- {{
                          lote.projectLot.description }}</span>
                      </div>
                    </td>
                    <td class="TEXT">
                      <!--span *ngIf="award.desierto">estado desierto</span>-->
                      <span pTooltip="{{ getStateDescription(award) }}">
                        <i class="fa" [ngClass]="getStateIcon(award)"></i> {{ getStateDescription(award) }}</span>
                    </td>
                    <td class="DATE">{{ award?.awardDate | date }}</td>
                    <td class="DATE">{{ award?.formalizationDate | date }}</td>
                    <td class=" text-center DATE">
                      <span *ngIf="award.desierto"></span>
                      <span *ngIf="!award.desierto && checkWarrantiesRegistered(award)">{{'General.yes' |
                        translate}}</span>
                      <span *ngIf="!award.desierto && !checkWarrantiesRegistered(award)">{{'General.no' |
                        translate}}</span>
                    </td>
                    <td class="action-column text-right">
                      <div class=" btn-group">
                        <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                          *ngIf="!award.desierto && isAwardAvailable(award) && isAwardEditAllowed() && awardHasLotEditAllowed(award)"
                          (click)="openAward({ award: award })" title="{{ 'General.edit' | translate }}">
                          <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-secondary t-action-button"
                          *ngIf="(!award.desierto) && allowDeleted && isAwardAvailable(award)  && awardHasLotEditAllowed(award)"
                          aria-expanded="false" (click)="removeAward(award)" title="{{ 'General.delete' | translate }}">
                          <i class="fas fa-times" aria-hidden="true"></i>
                        </button>
                        <button
                          *ngIf="award.desierto && this.project.breakdownLot.apportioned && !isFechaObligatoria(award.awardsLots[0].projectLot)"
                          class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                          (click)="reactivarLote(award)" title="{{ 'AwardInfo.buttonReactivateLot' | translate }}">
                          <i class="far fa-arrow-alt-circle-up"></i>
                        </button>
                        <!--<button *ngIf="award.desierto && isFechaObligatoria(award.awardsLots[0].projectLot)"
                      class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                      (click)="declaraNOAdj(lote)" pTooltip="{{ 'AwardInfo.buttonDesert' | translate }}"
                      title="{{ 'AwardInfo.buttonDesert' | translate }}">
                      <i class="fas fa-ban" aria-hidden="true"></i>
                    </button>-->
                        <button *ngIf="award.desierto && isFechaObligatoria(award.awardsLots[0].projectLot)"
                          class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                          (click)="declaraNOAdj(award.awardsLots[0].projectLot)"
                          title="{{ 'AwardInfo.DesertDate' | translate }}">
                          <i class="far fa-calendar-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr class="text-center">
                    <td colspan="9"
                      *ngIf="(!this.project?.breakdownLot.apportioned && !this.project?.breakdownLot.totalLots.rejectedLot)||this.project?.breakdownLot.apportioned">
                      No hay contratos registrados en el expediente </td>
                    <td class="col-icon"
                      *ngIf="!this.project?.breakdownLot.apportioned  && this.project?.breakdownLot.totalLots.rejectedLot">
                      <span><i class="fa fa-lg fa-file-signature m-b-sm text-danger"></i><span class="sr-only"></span>
                      </span>
                    </td>
                    <td
                      *ngIf="!this.project?.breakdownLot.apportioned  && this.project?.breakdownLot.totalLots.rejectedLot">
                      <i class="m-b-sm text-danger">Expediente {{
                        this.project.breakdownLot.totalLots.nonAwardResolutionType.description }}</i>
                    </td>
                    <td colspan="7"
                      *ngIf="!this.project?.breakdownLot.apportioned  && this.project?.breakdownLot.totalLots.rejectedLot">
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-panel>
        </div>
      </div>
      <!-- LISTADO DE LOTES -->
      <ng-container *ngIf="project?.breakdownLot.apportioned && (pendingLots&&pendingLots.length>0)">
        <div class="row m-t-md">
          <div class="col-12 p-0">
            <p-panel class="mb-3" [toggleable]="true">
              <p-header>
                <span>
                  <i class="fa fas fa-lg fa-clone"></i>
                  <span> {{ 'AwardInfo.pendingLots' | translate }}</span></span>
              </p-header>
              <div class="col-12">
                <p-table [value]="pendingLots" sortField="startInfo.date" sortOrder="1" [rows]="20" [paginator]="false"
                  [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]" class="footer-over-pagination mb-3"
                  [scrollable]="false" responsiveLayout="scroll">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="NUMBERTH th-wrap ">{{ 'AwardInfo.tableLots.number' | translate }}</th>
                      <th class="LONGTEXTTH th-wrap">{{ 'AwardInfo.tableLots.description' | translate }}</th>
                      <th class="TEXTTH th-wrap">{{ 'AwardInfo.tableLots.state' | translate }}</th>
                      <th class="action-column text-right">{{ 'AwardInfo.tableLots.actions' | translate }}</th>
                    </tr>
                  </ng-template>t <ng-template pTemplate="body" let-lote>
                    <tr *ngIf="isLotavailable(lote)">
                      <td class="NUMBER">{{ lote.lotNumber }}</td>
                      <td class="LONGTEXT">{{ lote.description }}</td>
                      <td class="TEXT">
                        <span *ngIf="!lote.rejectedLot">{{ 'AwardInfo.STATE_PENDING' | translate }} </span>
                        <span *ngIf="lote.rejectedLot">{{ lote.nonAwardResolutionType.description }} </span>
                      </td>
                      <td class="action-column text-right">
                        <div class="btn-group" *ngIf="!lote.rejectedLot">
                          <button *ngIf="!isAwardMultiplesLots() && allowInsert"
                            class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                            (click)="openAward({ lot: lote })" pTooltip="{{ 'AwardInfo.buttonAward' | translate }}"
                            title="{{ 'AwardInfo.buttonAward' | translate }}">
                            <i class="fas fa-plus" aria-hidden="true"></i>
                          </button>
                          <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                            (click)="declaraNOAdj(lote)" pTooltip="{{ 'AwardInfo.buttonDesert' | translate }}"
                            title="{{ 'AwardInfo.buttonDesert' | translate }}"
                            [attr.disabled]="!isDesertLotAvailable(lote) ? 'disabled' : null">
                            <i class="fas fa-ban" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="btn-group" *ngIf="lote.rejectedLot">
                          <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                            (click)="declaraNOAdj(lote)" pTooltip="{{ 'AwardInfo.buttonReactivateLot' | translate }}"
                            title="{{ 'AwardInfo.buttonReactivateLot' | translate }}">
                            <i class="far fa-arrow-alt-circle-up"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                  </ng-template>
                </p-table>
              </div>
            </p-panel>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<!--<p-dialog header="{{'AwardInfo.dataEdition.header'|translate}}" [(visible)]="showRejectedDate" [style]="{'width':'60%'}"
  [modal]=" true" [appendTo]="'body'" [responsive]="true" [resizable]="true">
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1" *ngIf="isInfoLoaded()">
    <div class="container-fluid" *ngIf="isInfoLoaded()">
      <div class="row m-t-md">
        <form autocomplete="off">
          <div class="col-12 d-flex input-group date justify-content-center m-t-md">
            <p-calendar [(ngModel)]="dateRejected" name="rejectedDate" [showIcon]="true" tabindex="2"
              [dateFormat]="PRIMENG_DATE_FORMAT" [firstDayOfWeek]=1 [inline]="true"></p-calendar>
          </div>
          <div class="col-12 d-flex justify-content-center m-t-md m-b-md">
            <button class="btn btn-sm btn-secondary" (click)="newCommunication()" appNoDblClick>
              <i class="fas fa-check"></i> {{'General.accept' | translate}} </button>
          </div>
        </form>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>-->
<p-dialog [resizable]="true" [style]="{'width':'60vw'}" [(visible)]="showValidationInfo" [closable]="true"
  [responsive]="true" [dismissableMask]="true" [closeOnEscape]="true" [modal]="true" [appendTo]="'body'"
  header="{{ 'Communications.audit.errorsTitle' | translate }} / {{ validationAward?.description }} / {{ validationAward?.company?.taxIdentifier }} - {{ validationAward?.company?.commercialName}}"
  (onHide)="closeValidationResult()">
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <validationResultMessages *ngIf="this.validationAward" [validationresult]="this.validationAward['validation']">
        </validationResultMessages>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>